import type { DefaultTheme } from 'styled-components'

const themeSettings: DefaultTheme = {
   colors: {
      primary: '#682994',
      primaryHover: '#7e4f9e',
      primaryActive: '#48156b',

      secondary: '#8f58c7',
      secondaryActive: '#6823ad',
      secondaryDisabled: '#c1abd6',

      grayDark: '#3d3d3d',
      dark: '#3d3d3d',
      grayMedium: '#7b7b7b',
      grayMediumLight: '#b8b8b8',
      grayLight: '#e0e0e0',
      white: '#FFF',

      layerBase: '#f8f8f8',
      layerSecond: '#f4f4f4',
      layerThird: '#f0f0f0',
      layerFourth: '#eee',
      layerBorder: '#d6d6d6',

      critical: '#f44336',
      warning: '#f5b04a',
      success: '#56ad45',
   },

   typography: {
      fontFamily: '"Roboto", sans-serif',
      fontSize: {
         xs: '0.75rem',
         sm: '0.875rem',
         md: '1rem',
         lg: '1.125rem',
         xl: '1.25rem',
      },
      fontWeight: {
         light: 300,
         regular: 400,
         medium: 500,
         bold: 700,
      },
   },
   border: {
      xs: '1px solid ',
      sm: '2px solid ',
   },
   borderRadius: {
      sm: '4px',
      md: '6px',
      lg: '8px',
      xl: '12px',
      xl2: '16px',
      xl3: '20px',
      xl4: '24px',
      xl5: '28px',
      xl6: '32px',
      xl7: '40px',
   },
   margin: {
      xs: '4px',
      sm: '8px',
      md: '12px',
      lg: '16px',
      xl: '20px',
      xl2: '24px',
      xl3: '28px',
      xl4: '32px',
      xl5: '36px',
      xl6: '40px',
      xl7: '44px',
      xl8: '48px',
   },
   padding: {
      xs: '4px',
      sm: '8px',
      md: '12px',
      lg: '16px',
      xl: '20px',
      xl2: '24px',
      xl3: '28px',
      xl4: '32px',
      xl5: '36px',
      xl6: '40px',
      xl7: '44px',
      xl8: '48px',
   },
   shadow: {
      sm: '0 1px 2px rgba(0, 0, 0, 0.12)',
      md: '0 2px 6px rgba(0, 0, 0, 0.16)',
      lg: '0 8px 24px rgba(0, 0, 0, 0.18)',
   },
   transition: {
      ease: 'all 0.2s ease',
      easeInOut: 'all 0.3s ease-in-out',
   },
   breakpoints: {
      xs: '320px',
      sm: '576px',
      md: '768px',
      lg: '992px',
      xl: '1200px',
   },
   zIndex: {
      dropdown: 1000,
      sticky: 1020,
      fixed: 1030,
      modal: 1050,
      popover: 1060,
   },
   apps: {
      apiPlatform: '#9A47C9',
      eventsHub: '#EB7246',
      serviceMesh: '#52a37a',
      flexibleActions: '#853a79',
      users: '#3689B3',
   },
}

export { themeSettings }
